/**
 * 매장 홍보 링크(https://jp2-user…?a=가입코드).
 *   gold 와 같이 쿠키 agentId 에 매장 가입코드를 기억해 두고, 회원가입 창을 열면 추천인 칸에 자동으로 채운다
 *   (사용자 지시 2026-10-19: 가입 창을 자동으로 열지는 않음, 채운 값은 고칠 수 있음).
 *   첫 화면(/)은 곧바로 /main·/m 으로 넘어가며 주소의 ?a= 가 사라지므로 앱이 켜질 때 먼저 읽어 둔다.
 */
const COOKIE = 'agentId'
const CODE_RE = /^[A-Za-z0-9_-]{1,20}$/

export function capturePromoCode() {
  try {
    const code = new URLSearchParams(window.location.search).get('a')
    if (!code || !CODE_RE.test(code)) return
    // 30일 기억(다른 매장 링크로 다시 들어오면 그 코드로 바뀐다)
    document.cookie = `${COOKIE}=${encodeURIComponent(code)}; path=/; max-age=${30 * 24 * 3600}; SameSite=Lax`
  } catch (e) {
    // 쿠키를 못 쓰는 브라우저면 홍보 링크 처리만 건너뛴다
  }
}

/** 기억해 둔 매장 가입코드(없으면 '') */
export function getPromoCode() {
  try {
    const m = document.cookie.match(/(?:^|;\s*)agentId=([^;]*)/)
    const code = m ? decodeURIComponent(m[1]) : ''
    return CODE_RE.test(code) ? code : ''
  } catch (e) {
    return ''
  }
}
